import { httpRequest } from '@/apis/request'

enum Apis {
  modelList = 'layout_model_list',
  model = 'layout_model',
}

/**
 * @description 获取排版图模板列表接口
 * @link https://api.thinkerx.com/web/#/162/16953
 */
export function fetchModelList() {
  return httpRequest.get(Apis.modelList)
}

/**
 * @description 获取具体排版图模板数据
 * @link https://api.thinkerx.com/web/#/162/16954
 */
export function fetchModelData(id: number) {
  return httpRequest.get(Apis.model, { id })
}

/**
 * @description 删除排版图模板
 * @link https://api.thinkerx.com/web/#/162/16955
 */
export function delModel(id: number) {
  return httpRequest.delete(Apis.model, { id })
}

/**
 * @description 保存排版图模板
 * @link https://api.thinkerx.com/web/#/162/16956
 */
export function saveModel(params: any) {
  return httpRequest.post(Apis.model, params)
}

/**
 * @description 修改排版图模板勾选状态
 * @link https://api.thinkerx.com/web/#/162/16963
 */
export function changeModelChecked(params: { id: number; status: number }) {
  return httpRequest.put(Apis.model, params)
}
